import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m8.333 12.643 7.66-7.66 1.18 1.178L8.333 15 3.03 9.697l1.178-1.179z" }));
export default SvgCheck;
